import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Terrain from "./views/Terrain.vue";
import Architecture from "./views/Architecture.vue";
import Surface from "./views/Surface.vue";
import Soussol from "./views/Soussol.vue";
import Finition from "./views/Finition.vue";
import Garage from "./views/Garage.vue";
import Carport from "./views/Carport.vue";
import Coordonnees from "./views/Coordonnees.vue";
import Merci from "./views/Merci.vue";

Vue.use(Router);

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/terrain",
			name: "Typologie de terrain",
			component: Terrain
		},
		{
			path: "/architecture",
			name: "Architecture",
			component: Architecture
		},
		{
			path: "/surface",
			name: "Surface",
			component: Surface
		},
		{
			path: "/finition",
			name: "Finition",
			component: Finition
		},
		{
			path: "/garage",
			name: "Garage",
			component: Garage
		},
		{
			path: "/carport",
			name: "Carport",
			component: Carport
		},
		{
			path: "/coordonnees",
			name: "Estimation",
			component: Coordonnees
		},
		{
			path: "/soussol",
			name: "Sous-sol",
			component: Soussol
		},
		{
			path: "/merci",
			name: "Merci",
			component: Merci
		}
	]
});
